export default {
    socketClient: null,
    socketId: '',
    notificationList: [],
  }